// extracted by mini-css-extract-plugin
export var preview = "ShareEntryPreview-module--preview--a2b20";
export var scrollArea = "ShareEntryPreview-module--scrollArea--e89b4";
export var shadow = "ShareEntryPreview-module--shadow--84241";
export var viewport = "ShareEntryPreview-module--viewport--09a50";